import {
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ElementRef,
  Renderer2,
  AfterViewInit,
  ViewChild,
} from '@angular/core';
import { ExamAgencies } from '../../../Models/ExamAgencies';
import { ExamManagementService } from '../../../Services/exam-management/exam-management.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../Services/session.service';
import {
  ICourseMaster,
  IExamAgency,
  IExamAgencyRequest,
} from './interfaces/exam-agency.interface';
import { StorageUtil } from 'src/app/utils';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ExamAgencyService } from './services/exam-agency.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sort.directive';
import { filter } from 'rxjs/operators';
import { StateService } from 'src/app/Services/stateServices/state.service';
export const compare = (
  v1: string | number | Date | null,
  v2: string | number | Date | null
): number => {
  // Handle null values explicitly
  if (v1 === null && v2 === null) return 0;
  if (v1 === null) return -1; // Treat null as the smallest value
  if (v2 === null) return 1;

  // Convert Date objects to timestamps
  const value1 = v1 instanceof Date ? v1.getTime() : v1;
  const value2 = v2 instanceof Date ? v2.getTime() : v2;

  // Compare the values
  return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
};

@Component({
  selector: 'app-exam-agencies',
  templateUrl: './exam-agencies.component.html',
  styleUrls: ['./exam-agencies.component.css'],
})
export class ExamAgenciesComponent implements OnInit {
  /**
   * Variables assigns
   */
  public examAgencies: Array<IExamAgency>;
  public unsortedexamAgencies: Array<IExamAgency>;
  public courseMasters: Array<ICourseMaster>;
  public unsortedcourseMasters: Array<ICourseMaster>;
  public examAgencyName: string;
  public examAgencyId: number;
  public sortColumn: keyof any;
  public sortDirection: 'asc' | 'desc' | '' = '';
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  examAgencyRequestParam: IExamAgencyRequest = {
    loggedInUserId: '',
    examAgencyId: '',
  };
  selectedCourseMaster: ICourseMaster;
  sortColumnCourseMaster: keyof any = '';
  sortDirectionCourseMaster: 'asc' | 'desc' | '' = '';
  keepstateSave = false;

  constructor(
    private readonly examAgencyService: ExamAgencyService,
    private readonly toaster: ToastrService,
    private readonly router: Router,
    private stateService: StateService
  ) {
    this.retrieveLoggedInUserId();
  }

  ngOnInit(): void {
    this.getExamAgenciesList();
  }
  ngAfterViewInit() {}
  private getExamAgenciesList() {
    if (!this.canMakeRequest()) return;

    // Make Request to get Results

    this.examAgencyService
      .getExamAgenciesList<Array<IExamAgency>>(
        this.examAgencyRequestParam.loggedInUserId
      )
      .subscribe((elem) => {
        this.examAgencies = elem;
        this.unsortedexamAgencies = elem;
        const alreadypresent = this.stateService.getPreviousPageState();
        if (
          this.examAgencies?.length &&
          alreadypresent &&
          alreadypresent.Exam_Agency_ID
        ) {
          const selectedIndex = this.examAgencies.findIndex(
            (e: IExamAgency) =>
              e.Exam_Agency_Id === alreadypresent.Exam_Agency_ID
          );
          this.getCourseMaster(
            this.examAgencies[selectedIndex >= 0 ? selectedIndex : 0]
          );
        } else {
          this.getCourseMaster(this.examAgencies[0]);
        }
      });
  }

  mutateExamAgency(edit: string, examAgency: IExamAgency) {
    if (edit == 'Edit' || edit === 'View') {
      this.keepstateSave = true;
      this.stateService.setPreviousPageState({
        Course_MatserId: null,
        Exam_Agency_ID: examAgency.Exam_Agency_Id,
      });
      this.router.navigateByUrl(
        `Exam/ExamAgencies/ViewEdit?type=${edit}&examAgencyId=${examAgency.Exam_Agency_Id}`
      );
    }
  }

  addExamAgency() {
    this.keepstateSave = false;
    this.router.navigateByUrl(
      `Exam/ExamAgencies/ViewEdit?type=Add&examAgencyId=`
    );
  }

  public getAlignment(value: any) {
    switch (typeof value) {
      case 'number':
        return 'justify-content-end';
      case 'string':
        return 'justify-content-start';
      case 'object':
        if (value instanceof Date) {
          return 'justify-content-start';
        } else if (value === null) {
          return '';
        } else {
          return '';
        }

      default:
        return '';
    }
  }

  /**
   * Get Course Master List
   *
   */
  getCourseMaster(examAgency: IExamAgency) {
    this.examAgencyName = examAgency.Exam_Agency_Name;
    this.examAgencyId = examAgency.Exam_Agency_Id;
    this.examAgencyService
      .getCourseMasterList(
        this.examAgencyRequestParam.loggedInUserId,
        examAgency.Exam_Agency_Id
      )
      .subscribe((elem) => {
        this.courseMasters = elem as Array<ICourseMaster>;
        this.unsortedcourseMasters = elem as Array<ICourseMaster>;
        let previousState = this.stateService.getPreviousPageState();
        if (previousState && previousState.Course_MatserId) {
          const selectedIndex = this.courseMasters.findIndex(
            (e: ICourseMaster) =>
              e.Course_Master_Id === previousState?.Course_MatserId
          );
          this.selectedCourseMaster = this.courseMasters[selectedIndex];
        }
      });
  }
  /**
   * Get User id from Local Storage
   */
  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.examAgencyRequestParam.loggedInUserId = loggedInUserId;
    return null;
  }

  /**
   * Checking Guards for making internal request
   *
   * @returns boolean
   */
  private canMakeRequest() {
    return this.examAgencyRequestParam.loggedInUserId ? true : false;
  }

  public addCourseMaster() {
    this.keepstateSave = false;
    this.router.navigateByUrl(
      `/Exam/ExamAgencies/CourseMaster/ViewEdit?type=Add&examAgencyId=${this.examAgencyId}&examAgencyName=${this.examAgencyName}`
    );
  }

  public editCourseMasterId(courseMaster: ICourseMaster) {
    this.stateService.setPreviousPageState({
      Exam_Agency_ID: courseMaster.Exam_Agency_Id,
      Course_MatserId: courseMaster?.Course_Master_Id,
    });
    this.keepstateSave = true;
    this.router.navigateByUrl(
      `/Exam/ExamAgencies/CourseMaster/ViewEdit?type=Edit&examAgencyId=${courseMaster.Exam_Agency_Id}&courseMasterId=${courseMaster.Course_Master_Id}`
    );
  }

  public getWebsiteLink(link: string) {
    const regex = new RegExp('^https?://');

    if (regex.test(link)) return link;

    return 'https://' + link;
  }

  public onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || column === '') {
      this.examAgencies = this.unsortedexamAgencies;
      this.sortColumn = '';
      this.sortDirection = '';
    } else {
      this.sortColumn = column;
      this.sortDirection = direction;
      this.examAgencies = [...this.unsortedexamAgencies].sort(
        (a: any, b: any) => {
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      );
    }
  }
  public onSortCourseMaster({ column, direction }: SortEvent) {
    // resetting other headers

    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '' || column === '') {
      this.courseMasters = this.unsortedcourseMasters;
      this.sortColumnCourseMaster = '';
      this.sortDirectionCourseMaster = '';
    } else {
      this.sortColumnCourseMaster = column;
      this.sortDirectionCourseMaster = direction;
      this.courseMasters = [...this.unsortedcourseMasters].sort(
        (a: any, b: any) => {
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      );
    }
  }
  public getFullAddress(examAgency: any): string {
    return [
      examAgency.Address_Line_1,
      examAgency.Address_Line_2,
      examAgency.Address_Line_3,
    ]
      .filter((address) => address)
      .join(', ');
  }

  public selectCourseMaster(courseMaster: ICourseMaster) {
    this.selectedCourseMaster = courseMaster;
  }

  ngOnDestroy() {
    if (!this.keepstateSave) {
      this.stateService.setPreviousPageState(null);
    }
  }
}
